/* eslint-disable import/prefer-default-export, no-param-reassign, new-cap */
// https://github.com/mapbox/mapbox-gl-js/issues/1338
import * as MapboxGl from 'mapbox-gl';

export const fitBoundsRotated = function(mapbox) {
    mapbox.fitBoundsRotated = function(bounds, options, eventData) {
        options = Object.assign(
            {
                padding: {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                },
                offset: [0, 0],
                maxZoom: this.transform.maxZoom,
            },
            options
        );

        if (typeof options.padding === 'number') {
            const p = options.padding;
            options.padding = {
                top: p,
                bottom: p,
                right: p,
                left: p,
            };
        }

        bounds = new MapboxGl.LngLatBounds.convert(bounds);

        // we separate the passed padding option into two parts, the part that does not affect the map's center
        // (lateral and vertical padding), and the part that does (paddingOffset). We add the padding offset
        // to the options `offset` object where it can alter the map's center in the subsequent calls to
        // `easeTo` and `flyTo`.
        const paddingOffset = [
            options.padding.left - options.padding.right,
            options.padding.top - options.padding.bottom,
        ];

        const lateralPadding = Math.min(options.padding.right, options.padding.left);
        const verticalPadding = Math.min(options.padding.top, options.padding.bottom);
        options.offset = [options.offset[0] + paddingOffset[0], options.offset[1] + paddingOffset[1]];
        options.bearing = options.bearing || this.getBearing();

        const offset = new MapboxGl.Point.convert(options.offset);
        const tr = this.transform;
        const nw = tr.project(bounds.getNorthWest());
        const se = tr.project(bounds.getSouthEast());
        const size = se.sub(nw);

        /** START CUSTOM ROTATION HACK * */
        // Now using a "cropped rectangle" rotation method
        // https://stackoverflow.com/questions/33866535/how-to-scale-a-rotated-rectangle-to-always-fit-another-rectangle
        // W = w·|cos φ| + h·|sin φ|
        // H = w·|sin φ| + h·|cos φ|
        const theta = options.bearing * (Math.PI / 180);
        const W = size.x * Math.abs(Math.cos(theta)) + size.y * Math.abs(Math.sin(theta));
        const H = size.x * Math.abs(Math.sin(theta)) + size.y * Math.abs(Math.cos(theta));
        const rotatedSize = { x: W, y: H };
        /** END CUSTOM ROTATION HACK * */
        const scaleX = (tr.width - lateralPadding * 2 - Math.abs(offset.x) * 2) / rotatedSize.x;
        const scaleY = (tr.height - verticalPadding * 2 - Math.abs(offset.y) * 2) / rotatedSize.y;
        if (scaleY < 0 || scaleX < 0) {
            if (typeof console !== 'undefined')
                console.warn('Map cannot fit within canvas with the given bounds, padding, and/or offset.');
            return this;
        }
        options.center = tr.unproject(nw.add(se).div(2));
        options.zoom = Math.min(tr.scaleZoom(tr.scale * Math.min(scaleX, scaleY)), options.maxZoom);
        return options.linear ? this.easeTo(options, eventData) : this.flyTo(options, eventData);
    };
    return mapbox;
};
